import React , { useEffect, useRef } from 'react';
import "./HistoriaDeVida.css";
import { Link } from 'react-router-dom'; // Importar Link
import { BuscadorHome } from '../../components/home/BuscadorHome';
import HeaderHome from '../../components/headerHome/HeaderHome'
import { MiFooter } from "../../components/footer/MiFooter";
import heroImg from "./img/historiaVidaHero2.png";
import formularioImg from "./img/formularioHistoria.png";
import planVidaImg from "./img/planVida.png";

export const HistoriaVida = () => {

    return (
        <>
            <HeaderHome />
            <main className="historia-vida">
            {/* HERO */}
            <section className="funcionalidades-hero">
            <div className="hero-image">
                <img src={heroImg} alt="Historia de Vida" />
            </div>
            <div className="hero-card">
                <h1>Historia de Vida</h1>
                <p>
                    La <b>Historia de Vida</b> constituye el corazón de Cuidatia.
                    Reúne todo aquello que hace única a una persona para que los
                    cuidados se adapten realmente a sus <b>necesidades</b>,
                    <b> preferencias</b> y <b>proyecto de vida</b>.
                </p>
            </div>
            </section>

            {/* INFORMACIÓN E INTRODUCCIÓN */}

            <section className="historia-section">
                <div className="titulo-contenedor">
                    <h2 className="titulo-verde">
                        Construyendo la Historia de Vida
                    </h2>
                </div>
                <div className="historia-doble-columna">
                    {/* Columna izquierda */}
                    <div className="historia-columna">
                        <h3>¿Qué información recoge?</h3>
                        <p>
                            La Historia de Vida reúne la información más importante para
                            conocer a la persona y ofrecer unos cuidados realmente
                            personalizados.
                        </p>
                        <ul>
                            <li>Biografía</li>
                            <li>Relaciones familiares y sociales</li>
                            <li>Preferencias y gustos</li>
                            <li>Rutinas y hábitos diarios</li>
                            <li>Valores y creencias</li>
                            <li>Necesidades y apoyos</li>
                            <li>Capacidades conservadas</li>
                            <li>Objetivos y proyecto de vida</li>
                        </ul>
                    </div>
                    {/* Columna derecha */}
                    <div className="historia-columna">
                        <h3>¿Cómo se recoge?</h3>
                        <p>
                            La información puede incorporarse de distintas formas para
                            facilitar la participación de la persona, la familia y los
                            profesionales.
                        </p>
                        <ul>
                            <li>Cuestionario digital</li>
                            <li>Acceso mediante código QR</li>
                            <li>Entrevistas personales</li>
                            <li>Grabaciones de voz</li>
                            <li>Participación de familiares</li>
                            <li>Fotografías y vídeos</li>
                            <li>Información aportada por profesionales</li>
                        </ul>
                    </div>
                </div>
            </section>

                {/* IA */}

                <section className="historia-banner">

                    <div className="banner-imagen">
                        <img src={formularioImg} alt="Historia de Vida" />
                    </div>

                    <div className="banner-texto">

                        <div className="titulo-contenedor">
                            <h2 className="titulo-verde">
                                ¿Cómo ayuda la Inteligencia Artificial?
                            </h2>
                        </div>

                        <p>
                            La Inteligencia Artificial actúa como una herramienta de apoyo que
                            facilita el tratamiento de la información recogida durante la elaboración
                            de la Historia de Vida, <b>transcribiendo entrevistas de voz</b>,
                            organizar datos de cuestionarios, guardando fotografías, y <b>clasificando la información</b>
                             según el rol que vaya a emplearla.
                        </p>

                        <p>
                            Además, identifica los aspectos más relevantes para la atención de la persona,
                            genera <b>resúmenes estructurados</b>, detecta información que puede requerir
                            revisión y elabora recomendaciones y actividades adaptadas al perfil de cada usuario.
                            Todo ello reduce el tiempo dedicado a tareas administrativas y permite que los
                            profesionales dispongan de una visión global, organizada y actualizada de la
                            persona, favoreciendo una atención más personalizada y centrada en sus objetivos
                            y proyecto de vida.
                        </p>

                        <div className="nota">
                            La decisión final corresponde siempre al equipo profesional.
                        </div>

                    </div>

                </section>

                {/* RESULTADOS */}

                <section className="historia-banner reverse">

                    <div className="banner-imagen">
                        <img src={planVidaImg} alt="Plan de Atención y Vida" />
                    </div>

                    <div className="banner-texto">

                        <div className="titulo-contenedor">
                            <h2 className="titulo-verde">
                                ¿Qué genera?
                            </h2>
                        </div>
                        <div className = "historia-columna">
                        <ul>
                            <li>Pictograma personal.</li>
                            <li>Perfil completo.</li>
                            <li>Plan de Atención y Vida.</li>
                            <li>Recomendaciones personalizadas.</li>
                            <li>Actividades significativas.</li>
                            <li>Información para cuidadores.</li>
                            <li>Resumen para familiares.</li>
                        </ul>
                        </div>

                    </div>

                </section>

            </main>

            <MiFooter />

        </>
    );

};